export default {
    BRASILEIRO: 1,
    ESTRANGEIRO: 2,
    NATURALIZADO_BRASILEIRO: 3
}